import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  fetchCompany,
  createSMSTemplate,
  fetchSMSTemplateCategories,
  fetchVideoTemplates,
  createTestSMS
} from "../actions/index";
import SMSTemplatesForm from "./SMSTemplatesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import * as Constants from '../constants';

class SMSTemplatesNew extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    createSMSTemplate: PropTypes.func.isRequired,
    fetchSMSTemplateCategories: PropTypes.func.isRequired,
    fetchVideoTemplates: PropTypes.func.isRequired,
    createTestSMS: PropTypes.func.isRequired,
    categories: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      site_domain: null
    };
  }

  componentDidMount() {
    this.props.fetchSMSTemplateCategories();
    this.props.fetchVideoTemplates();
    this.props.fetchCompany().then(response => {
      if (response.payload.status == 200) {
        this.setState({ site_domain: response.payload.data.data.site_domain });
      }
    });
  }

  sendTestSMS(state) {
    this.props
      .createTestSMS(state)
      .then(response => {
        if (response.payload.status == 200) {
          toastr.success("Test SMS Sent!");
        }
      });
  }

  onSubmit(state) {
    this.props
      .createSMSTemplate(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("SMS Template created!");
          this.props.history.push(`/sms_templates?${Constants.DEFAULT_PAGINATION}`);
        }
      });
  }

  videoSMS() {
    let query = new URLSearchParams(this.props.location.search);
    let s3_url = query.get('s3_url');
    // let duration = query.get('duration');
    // let durationText = "";
    //
    // if (duration && duration != "") {
    //   let durArr = duration.split(":");
    //   let durMinutes = parseInt(durArr[0]);
    //   let durSeconds = parseInt(durArr[1]);
    //   if (durMinutes > 0) {
    //     durationText = durMinutes + " minute ";
    //   } else {
    //     durationText = durSeconds + " second ";
    //   }
    // }

    if (s3_url) {
      let arr = s3_url.split("/");
      let id = arr[arr.length - 1].split('.').slice(-2)[0] ;
      let urlArr = s3_url.split(".");
      urlArr.pop();
      let url = urlArr.join('.');
      let siteDomain = this.state.site_domain;
      return "Check out this video I made you:\nhttp://" + siteDomain + "/vid/" + id +"?login={{LEAD_UUID}}";
    } else {
      return "";
    }
  }

  render() {
    const { categories, videoTemplates } = this.props;
    let body = "Hi {{FIRST_NAME}}, \n\n" + this.videoSMS() + "  \n\n{{AGENT_EMAIL_SIGNATURE}}";
    if (categories === undefined || videoTemplates === undefined || !categories.data || !videoTemplates.data || !this.state.site_domain) {
      return (
        <div className="vertical-center">
          <CSSTransitionGroup
            transitionName="spinner"
            transitionAppear={true}
            transitionAppearTimeout={500}
          >
            <i className="fa fa-refresh fa-4x fa-spin" />
          </CSSTransitionGroup>
        </div>
      );
    }
    return (
      <div>
        <h1>Add New SMS Template</h1>
        <SMSTemplatesForm
          handleSubmit={this.onSubmit.bind(this)}
          categories={categories.data}
          videoTemplates={videoTemplates.data}
          match={this.props.match}
          handleSendTestSMS={this.sendTestSMS.bind(this)}
          body_text={body}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { categories: state.smsTemplateCategories.all, videoTemplates: state.videoTemplates.all };
}

export default connect(
  mapStateToProps,
  { fetchCompany, createSMSTemplate, fetchSMSTemplateCategories, createTestSMS, fetchVideoTemplates }
)(SMSTemplatesNew);
